import React, { forwardRef } from 'react';

interface ProfileFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const ProfileFull = forwardRef<HTMLElement, ProfileFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-user ${classes}`} style={style}></i>
  );
});

ProfileFull.displayName = 'ProfileFull';
